import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
    prefix: 'tw-',
});

export function tailwindMerge(...inputs) {
    return twMerge(clsx(inputs));
}
